import React from 'react'

export default function ICalendar( props ) {
  return (
    <svg width="26" height="29" viewBox="0 0 26 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2.88889 28.2026H23.1111C24.7043 28.2026 26 26.9468 26 25.4026V5.80264C26 4.25844 24.7043 3.00264 23.1111 3.00264H20.2222V0.202637H17.3333V3.00264H8.66667V0.202637H5.77778V3.00264H2.88889C1.29567 3.00264 0 4.25844 0 5.80264V25.4026C0 26.9468 1.29567 28.2026 2.88889 28.2026ZM23.1111 8.60264L23.1126 25.4026H2.88889V8.60264H23.1111Z" fill="black"/>
    </svg>
  )
}